import React from "react";
import { default as MUIListItemText } from "@mui/material/ListItemText";
import styled from "styled-components";

const StyledMUIListItemText = styled(MUIListItemText)``;

export const ListItemText = ({ component }) => {
  return <StyledMUIListItemText component={component} />;
};
